import { render, staticRenderFns } from "./PCMIReportsTranslation.vue?vue&type=template&id=6395a730&scoped=true&"
import script from "./PCMIReportsTranslation.vue?vue&type=script&lang=js&"
export * from "./PCMIReportsTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395a730",
  null
  
)

export default component.exports